// src/api/uploadApi.ts
import {apiClient} from "./axios.ts";

export interface FileUploadResponse {
    fileUrl: string;
    fileName: string;
    fileSize: number;
}

export const uploadApi = {
    // 이미지 파일 업로드
    uploadImage: async (file: File, folder: string = 'library', options?: { maxDimension?: number; quality?: number }): Promise<FileUploadResponse> => {
        // folder는 query string 단일 소스로 전달. FormData에 중복 append 하면 Spring
        // @RequestParam(folder) 가 query+form 값을 콤마로 join 해서 R2 키에
        // "eppi-costumes,eppi-costumes/..." 처럼 중복 폴더가 박힌다.
        const formData = new FormData();
        formData.append('file', file);

        const params = new URLSearchParams();
        params.append('folder', folder);
        if (options?.maxDimension) params.append('maxDimension', options.maxDimension.toString());
        if (options?.quality) params.append('quality', options.quality.toString());

        return await apiClient.postMultipart<FileUploadResponse>(
            `/admin/upload/file?${params.toString()}`,
            formData
        );
    },

    // 파일 삭제
    deleteFile: async (fileUrl: string): Promise<void> => {
        await apiClient.deleteNoData(`/admin/upload/${fileUrl}`);
    },
};
